import { AuthCard } from '../components/AuthCard'

/**
 * `/account-reset#email=…&code=…`, the link in a StoreKeeper password reset email. On a device with StoreKeeper the
 * app opens it instead (apple-app-site-association); here, it opened in a browser, so show the code to enter in the
 * app. The fragment is read on this page only; it is never sent to the server.
 */
export function StoreKeeperResetScreen() {
	const params = new URLSearchParams(window.location.hash.slice(1))
	const code = params.get('code')
	return (
		<AuthCard title="Reset your StoreKeeper password">
			{code ? (
				<>
					<p>Enter this code in StoreKeeper with your new password:</p>
					<p className="reset-code" aria-label="Reset code">
						{code}
					</p>
				</>
			) : (
				<p>This link is missing its code. Use the code from the email instead.</p>
			)}
			<p className="muted small">
				In StoreKeeper, open Settings › Account › Sign In › Forgot Password?. The code works for an hour from when it
				was sent.
			</p>
		</AuthCard>
	)
}
